// ViewReservationModal.jsx
// components/modals/ViewReservationModal.jsx
import React from 'react';
import styles from '../components/ReservationTable.module.css'; // Adjust path as needed
import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';

const ViewReservationModal = ({ isOpen, onClose, reservation }) => {
  if (!isOpen || !reservation) return null;

  const handleDownloadPdf = () => {
    const input = document.getElementById('bookingVoucher');
    if (!input) {
      alert('Booking voucher content not found for PDF generation.');
      return;
    }

    const originalOverflowY = input.style.overflowY;
    const originalMaxHeight = input.style.maxHeight;

    input.style.overflowY = 'visible';
    input.style.maxHeight = 'none';

    html2canvas(input, { scale: 2 }).then((canvas) => {
      const imgData = canvas.toDataURL('image/png');
      const pdf = new jsPDF('p', 'mm', 'a4');
      const imgWidth = 210;
      const pageHeight = 297;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;
      let heightLeft = imgHeight;
      let position = 0;

      pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;

      while (heightLeft >= 0) {
        position = heightLeft - imgHeight;
        pdf.addPage();
        pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;
      }
      pdf.save(`Booking_Voucher_ID_${reservation.id}.pdf`);
    }).catch(err => {
      console.error('Error generating PDF:', err);
      alert('Failed to generate PDF. Please try again.');
    }).finally(() => {
      input.style.overflowY = originalOverflowY;
      input.style.maxHeight = originalMaxHeight;
    });
  };

  return (
    <div className={styles.modalOverlay}>
      <div id="bookingVoucher" className={styles.viewModalContent}>
        <button className={styles.modalCloseButton} onClick={onClose}>&times;</button>
        <div className={styles.voucherHeader}>
          <div className={styles.hotelInfo}>
            <h2 className={styles.hotelName}>Hotel The Pride</h2>
            <p className={styles.hotelAddress}>267, Rajeev Gandhi Nagar, near Allen<br />Sankalp, Kota, Rajasthan - 324005</p>
          </div>
          <div className={styles.contactInfo}>
            <p>+91 960 267 9997</p>
            <p>0744 3500036</p>
            <p>reservationhotelthepride@gmail.com</p>
          </div>
        </div>

        <h1 className={styles.voucherTitle}>BOOKING VOUCHER</h1>

        <div style={{ marginBottom: '20px' }}>
          <div className={styles.detailRow}>
            <span className={styles.detailLabel}>Booking ID :</span>
            <span className={styles.detailValue}>#{reservation.id}</span>
          </div>
          <div className={styles.detailRow}>
            <span className={styles.detailLabel}>Date of Invoice :</span>
            <span className={styles.detailValue}>{new Date().toLocaleDateString()}</span>
          </div>
          <div className={styles.detailRow}>
            <span className={styles.detailLabel}>Time :</span>
            <span className={styles.detailValue}>{new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}</span>
          </div>
          <div className={styles.detailRow}>
            <span className={styles.detailLabel}>Submitted At :</span>
            <span className={styles.detailValue}>{new Date(reservation.submittedAt).toLocaleString()}</span>
          </div>
        </div>

        <h3 className={styles.sectionHeader}>Guest Details</h3>
        <div style={{ marginBottom: '20px' }}>
          <div className={styles.detailRow}>
            <span className={styles.detailLabel}>Name :</span>
            <span className={styles.detailValue}>{reservation.name}</span>
          </div>
          <div className={styles.detailRow}>
            <span className={styles.detailLabel}>Contact No. :</span>
            <span className={styles.detailValue}>{reservation.phone}</span>
          </div>
          <div className={styles.detailRow}>
            <span className={styles.detailLabel}>Number of Guests :</span>
            <span className={styles.detailValue}>{reservation.guests}</span>
          </div>
        </div>

        <h3 className={styles.sectionHeader}>Booking Details</h3>
        <div style={{ marginBottom: '20px' }}>
          <div className={styles.detailRow}>
            <span className={styles.detailLabel}>Check-in Date & Time:</span>
            <span className={styles.detailValue}>{new Date(reservation.checkIn).toLocaleString()}</span>
          </div>
          <div className={styles.detailRow}>
            <span className={styles.detailLabel}>Check-out Date & Time:</span>
            <span className={styles.detailValue}>{new Date(reservation.checkOut).toLocaleString()}</span>
          </div>
          <div className={styles.detailRow}>
            <span className={styles.detailLabel}>Room Type :</span>
            <span className={styles.detailValue}>{reservation.roomType}</span>
          </div>
          <div className={styles.detailRow}>
            <span className={styles.detailLabel}>Assigned Room No. :</span>
            <span className={styles.detailValue}>{reservation.assignedRoomNumber || 'Not Yet Assigned'}</span>
          </div>
          <div className={styles.detailRow}>
            <span className={styles.detailLabel}>Meal Plan :</span>
            <span className={styles.detailValue}>{reservation.mealPlan}</span>
          </div>
          <div className={styles.detailRow}>
            <span className={styles.detailLabel}>Special Request :</span>
            <span className={styles.detailValue}>{reservation.specialRequest || 'None'}</span>
          </div>
          <div className={styles.detailRow}>
            <span className={styles.detailLabel}>Booking Status :</span>
            <span className={styles.detailValue}>{reservation.status}</span>
          </div>
        </div>

        <h3 className={styles.sectionHeader}>Service Description</h3>
        <table className={styles.serviceTable}>
          <thead>
            <tr>
              <th className={styles.serviceTableHeader}>Service Description</th>
              <th className={styles.serviceTableHeader}>Quantity</th>
              <th className={styles.serviceTableHeader}>Unit Price (Est.)</th>
              <th className={styles.serviceTableHeader}>Total (Est.)</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className={styles.serviceTableCell}>{reservation.roomType}</td>
              <td className={styles.serviceTableCell}>1</td>
              <td className={styles.serviceTableCell}>₹ N/A</td>
              <td className={styles.serviceTableCell}>₹ N/A</td>
            </tr>
            <tr>
              <td className={styles.serviceTableCell}>Meal Plan ({reservation.mealPlan})</td>
              <td className={styles.serviceTableCell}>-</td>
              <td className={styles.serviceTableCell}>-</td>
              <td className={styles.serviceTableCell}>-</td>
            </tr>
            <tr>
              <td className={styles.serviceTableCell}>Additional Services</td>
              <td className={styles.serviceTableCell}>-</td>
              <td className={styles.serviceTableCell}>-</td>
              <td className={styles.serviceTableCell}>-</td>
            </tr>
          </tbody>
        </table>

        <div className={styles.totalSection}>
          <div className={styles.totalRow}>
            <span className={styles.totalLabel}>Estimated Total:</span>
            <span className={styles.totalValue}>₹ N/A</span>
          </div>
          <div className={styles.totalRow}>
            <span className={styles.totalLabel}>Amount Paid:</span>
            <span className={styles.totalValue}>₹ N/A</span>
          </div>
          <div className={styles.totalRow}>
            <span className={styles.totalLabel}>Balance Due:</span>
            <span className={styles.totalValue}>₹ N/A</span>
          </div>
        </div>

        <div className={styles.noteSection}>
          <p className={styles.noteTitle}>Hotel Policies:</p>
          <ul>
            <li>Suitable for children</li>
            <li>Credit/Debit cards are accepted</li>
            <li>Only Government ID (Aadhar Card and Govt. ID are accepted as ID proofs)</li>
            <li>PAN Card, Driving License and Office ID are not accepted as ID proofs)</li>
            <li>Pets are not allowed</li>
          </ul>
          <p className={styles.noteTitle}>Cancellation Policy:</p>
          <ul>
            <li>Free Cancellation is available before 1 day of arrival.</li>
            <li>No refund if cancelled within 1 day of arrival.</li>
          </ul>
        </div>
        <button
          className={styles.downloadButton}
          onClick={handleDownloadPdf}
        >
          Download as PDF
        </button>
      </div>
    </div>
  );
};

export default ViewReservationModal;